/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { IHerbalFaqsViewProps } from './herbal-faqs';

export default (props: IHerbalFaqsViewProps) => {
    const { resources, moduleProps, containerProps, faqItems, expandedIndex, toggleFaq } = props;

    const containerStyles: React.CSSProperties = {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '40px 20px'
    };

    const titleStyles: React.CSSProperties = {
        textAlign: 'center',
        fontSize: '32px',
        fontWeight: 400,
        marginBottom: '40px'
    };

    return (
        <Module {...moduleProps}>
            <Node {...containerProps}>
                <div style={containerStyles}>
                    <h2 style={titleStyles}>{resources.faqTitle}</h2>
                    <div className='herbal-faqs__list'>
                        {faqItems.map((faq, index) => (
                            <div key={index} className='herbal-faqs__item'>
                                <div className='herbal-faqs__question' onClick={() => toggleFaq(index)}>
                                    <div className='herbal-faqs__question-text'>{faq.question}</div>
                                    <button
                                        className='herbal-faqs__toggle'
                                        aria-expanded={expandedIndex === index}
                                        aria-controls={`faq-answer-${index}`}
                                    >
                                        {expandedIndex === index ? '−' : '+'}
                                    </button>
                                </div>
                                {expandedIndex === index && (
                                    <div
                                        id={`faq-answer-${index}`}
                                        className='herbal-faqs__answer'
                                        dangerouslySetInnerHTML={{
                                            __html: typeof faq.answer === 'string' ? faq.answer : String(faq.answer)
                                        }}
                                    />
                                )}
                                <div className='herbal-faqs__divider'></div>
                            </div>
                        ))}
                    </div>
                </div>
            </Node>
        </Module>
    );
};
